/**
 * Política de aparición del aviso de pago atrasado.
 *
 * Función pura: el layout del dashboard solo cablea (consultar config, leer y
 * escribir la marca de sesión, renderizar) y delega acá la decisión.
 */

/**
 * @param {object} params
 * @param {string} params.modo — 'ninguna' | 'una_vez' | 'siempre'
 * @param {string} params.pathname — ruta actual del dashboard
 * @param {string|null} params.pathnameAnterior — ruta en la que se evaluó la vez previa
 * @param {boolean} params.yaSeMostroEnSesion — marca de sesión del navegador, por empresa
 * @returns {boolean}
 */
export const debeMostrarAlertaPago = ({
  modo,
  pathname,
  pathnameAnterior = null,
  yaSeMostroEnSesion = false,
} = {}) => {
  if (!pathname) return false;

  if (modo === 'una_vez') return !yaSeMostroEnSesion;

  // 'siempre': primera pantalla de la sesión y cada cambio de ruta posterior.
  if (modo === 'siempre') return pathname !== pathnameAnterior;

  return false;
};
